import React from 'react';

import EnterLayout from '../../components/layout/EnterLayout';
import SignUpForm from '../../components/Enter/SignUpForm';

const SignUpRoute = () => (
  <EnterLayout verticalPaddings={[50, 40]} showTermsAndPolicy>
    <SignUpForm />
  </EnterLayout>
);

export default SignUpRoute;
